import { Component, OnInit, Input, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-door-supervision',
  templateUrl: './door-supervision.component.html',
  styleUrls: ['./door-supervision.component.scss']
})
export class DoorSupervisionComponent implements OnInit {


  @Input('job') singleJob;
  @Input('learner') singleLearner;
  @Input('assessment') assessmentEdit;
  jobData
  learnerData
  doorEdit

  constructor() { }

  ngOnInit() {
  }




  ngOnChanges(changes: SimpleChanges) {
    console.log("changes in Door Supervisior course", changes);
    if (changes.singleLearner && changes.singleLearner.currentValue) {
      this.learnerData = changes.singleLearner.currentValue._id
    }

    if (changes.singleJob && changes.singleJob.currentValue) {
      this.jobData = changes.singleJob.currentValue
    }

    if (changes.assessmentEdit && changes.assessmentEdit.currentValue) {
      console.log("changes.assessmentEdit.currentValue in master", changes.assessmentEdit.currentValue)
      this.doorEdit = changes.assessmentEdit.currentValue
      console.log("assement plan edit data", this.assessmentEdit);
    }
  }

}
